import { useColorModeValue } from '@chakra-ui/color-mode';
import { Box, Center, Link, SimpleGrid } from '@chakra-ui/layout';
import { PAGE_LINKS } from '../utils/constants';
import { VStack } from '@chakra-ui/react';

const Footer = () => {
	const bgColor = useColorModeValue('gray.300', 'gray.900');

	const navigateToSection = link => {
		const sectionId = link.substr(1);
		document.getElementById(sectionId).scrollIntoView({ behavior: 'smooth' });
	}

	return (
		<Box
			p={5}
			background={bgColor}
			boxShadow='lg'
			borderRadius='lg'
		>
			<Center>
				<VStack direction="row" spacing="9px">
					<SimpleGrid>
						{PAGE_LINKS.map((link) => (
							<Link key={link} mb={{ base: '1rem', sm: 0 }} onClick={() => navigateToSection(link)} textAlign='center'>{link}</Link>
						))}
					</SimpleGrid>
				</VStack>
			</Center>
		</Box>
	);
};

export default Footer;
